import { FC } from 'react';

import Container from 'quarks/Container';

interface AushaPlayerProps extends BasicProps {
  episodeId: string;
}

const AushaPlayer: FC<AushaPlayerProps> = ({ episodeId }) => (
  <Container
    className="podcast-player"
    css={`
      width: calc(100% + 20px);
      overflow: hidden;

      iframe {
        border: none;
        width: 100%;
        height: 220px;
        width: 100%;
      }
      @media (max-width: 575px) {
        iframe {
          height: 220px;
        }
      }
    `}
  >
    <iframe
      name="Ausha Podcast Player"
      frameBorder="0"
      title="Ausha Podcast Player"
      loading="lazy"
      id="ausha-Q6Ce"
      src={`https://player.ausha.co/?showId=ZgVxDHm98MML&&podcastId=${episodeId}&v=3display=horizontal&color=%23110c39&playerId=ausha-Q6Ce&display=horizontal`}
    ></iframe>
    <script src="https://player.ausha.co/ausha-player.js"></script>
  </Container>
);

export default AushaPlayer;
